import styled from 'styled-components6';
import {
    AnalyticsTargetLayerAreaProvider,
    getPageUrl,
    useAnalyticsClickEvent,
} from 'rwl-ui';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';
import { SplitNavigationButtons } from '../../buttons';
import { MobileDetailsHeader } from '../DetailsHeader';
import { Panes } from './Panes';
import { useContentDetails } from '../../../providers';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';

const Container = styled.div`
    margin-top: var(--rwl-spacing-lg);
    gap: var(--rwl-spacing-md);
    display: flex;
    flex-direction: column;
`;

const Card = styled.div`
    border: 1px solid var(--rwl-palette-gray-300);
    border-radius: var(--rwl-radius-sm);
    overflow: hidden;
    max-width: 100%;
`;

export const SplitDetails = () => {
    const { currentIndex, hasMore, onNext, onPrev } = useContentDetails();
    const sendClickEvent = useAnalyticsClickEvent();

    return (
        <AnalyticsTargetLayerAreaProvider
            targetLayerArea={TargetLayerArea.MEDIA}
        >
            <Container>
                <Card>
                    <MobileDetailsHeader />
                    <Panes />
                </Card>
                <SplitNavigationButtons
                    currentIndex={currentIndex}
                    hasMore={hasMore}
                    onNext={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.NEXT,
                        });
                        onNext();
                    }}
                    onPrev={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.PREV,
                        });
                        onPrev();
                    }}
                    nextText="Next project"
                    prevText="Previous project"
                />
            </Container>
        </AnalyticsTargetLayerAreaProvider>
    );
};
